import Toggle from '../../components/toggleButton/ToggleButton';
import NavBar from './navbar/navBar';
import './recoveryContractModification.scss';
import DateInput from '../../components/dateInput/DateInput';
import { useState } from 'react';
const recoveryContractModification = () => {
    const [value, setValue] = useState(0);
    return (
        <div className="recoveryContractModificationComponent">
            <NavBar />
            <div className="container">
                <div className="breadCrumb">
                    <div className="mainScreen">직원목록</div> {'>'}
                    <div className="secondScreen">근무일정</div>
                </div>

                <div className="nameContainer">
                    <div className="image">길동</div>
                    <div className="nameText">홍길동</div>
                </div>

                <div className="cardContainer">
                    <div className="leftContainer">
                        <div className="titleBar">
                            <div className="title">수습계약 </div>
                            <Toggle
                                toggled={false}
                                disabled={false}
                                onClick={() => { }}
                            />
                        </div>

                        <div className="titleRow">
                            <div className="firstTitle">수습계약 시작일*</div>
                            <div className="secondTitle">수습계약 종료일*</div>
                        </div>

                        <div className="dateRow">
                            <DateInput title={'수습계약 시작일*'} />
                            <div className="datePicker">
                                <DateInput title={'수습계약 종료일*'} />
                            </div>
                        </div>

                        <div className="percentageInputRow">
                            <div className="header">수습 급여 비율*</div>

                            <div className="container">
                                <div className="labelText">급여지급율</div>
                                <div className="inputBox">
                                    <input
                                        type="text"
                                        pattern="[0-9]*"
                                        value={value}
                                        onChange={(e) =>
                                            setValue((v) => (e.target.validity.valid ? Number(e.target.value) : v))
                                        }
                                    />
                                    <div className="percentage">%</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="rightContainer">
                        <div className="title">급여계산</div>
                        <div className="description">입력하신 ‘수습계약 시작일'부터 ‘수습계약 종료일’ 까지의 기간 동안 ‘급여지급율’에 따라 일할 계산됩니다</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default recoveryContractModification;
